module.exports = __webpack_public_path__ + "components/country-flag/static/za-4d652bbb6e3683a9ef656b35fea83a92.svg";